import vanillaSelectBox from '../components/select';

const scFilter = () => {
  const filter = document.querySelectorAll('.mod_sc_data_filter .widget-select');

  filter.forEach((select) => {
    const selectId = '#' + select.querySelector('select').id;
    const selectLabel = select.querySelector('label');
    const selectLabelContent = select.querySelector('label').textContent;

    if(selectLabel) {
      selectLabel.style.display = 'none';
    }

    // const multiple
    new vanillaSelectBox(selectId,{
      'maxHeight':300,
      'placeHolder': selectLabel ? selectLabelContent : '',
      'disableSelectAll': true,
      'keepInlineStyles': false,
      // 'search':true,
      'translations': { 'all': 'All', 'items': 'Ausgewählt' }
    });
  });
}

export default scFilter;
